










import {Component, Emit, Prop} from 'vue-property-decorator'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import srLocale from '@fullcalendar/core/locales/sr';

@Component({components: {'full-calendar': FullCalendar}})
export default class CalendarComponent extends mixins(ComponentBaseMixin) {
    @Prop() dataLoader!: () => Promise<any>;
    @Prop() eventStyler!: (event: any) => void;
    calendarPlugins = [dayGridPlugin, interactionPlugin];
    locale = srLocale;

    async events(info, successCallback, failureCallback) {
        try {
            const data = await this.loadData(() => this.dataLoader())();
            successCallback(data);
        } catch (err) {
            failureCallback(err);
        }
    };

    eventClick(info) {
        this.eventClicked(info.event.extendedProps);
    }

    handleDateClick(arg) {
        this.dateClicked(arg.date);
    }

    eventAfterRender(event) {
        this.eventStyler(event);
    }

    reload() {
        let calendar = (<any>this.$refs.fullCalendar).getApi();
        calendar.refetchEvents();
    }

    @Emit() eventClicked(payload: any) {
    }

    @Emit() dateClicked(date: Date) {
    }

}
